const StoreInventoryDisclaimer = () => {
  const disclaimer = document.createElement('div');
  disclaimer.className = 'StoreInventoryDisclaimer';
  disclaimer.setAttribute('data-inventory-disclaimer-msg', '');

  const message = document.createElement('span');
  message.className = 'StoreInventoryDisclaimer__message';
  message.textContent = "Product availability changes frequently and isn't guaranteed.";

  disclaimer.appendChild(message);

  return disclaimer;
};

export default StoreInventoryDisclaimer;
